export enum HistoryType {
  MESSAGES = 'Messages',
  REWARDS = 'Rewards',
}
